"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const HabitIconList = ({ className, habitJourneys, onHabitClicked }) => (react_1.default.createElement("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.habits, className) }, habitJourneys.map(({ id, icon, primaryColor, secondaryColor }) => (react_1.default.createElement(components_1.HabitIcon, { key: id, className: styles_scss_1.default.habit, image: icon.url.medium, onClick: () => onHabitClicked(id), colors: [primaryColor, secondaryColor] })))));
HabitIconList.defaultProps = {
    className: undefined,
};
exports.default = HabitIconList;
